<template>
  <div class="video-upload-input">
    <div class="form-label" v-if="label">
      <label>{{ label }}</label>
    </div>
    
    <!-- Preview do vídeo -->
    <div class="video-preview-wrapper" v-if="previewUrl">
      <div class="video-preview-container">
        <video
          :src="previewUrl"
          controls
          class="video-preview"
        >
          Seu navegador não suporta o elemento de vídeo.
        </video>
        <button 
          class="remove-preview-btn" 
          @click="removePreview"
          type="button"
          title="Remover vídeo"
        >
          <fa icon="fa-times" />
        </button>
      </div>
      <div class="video-upload-progress" v-if="uploading || progress > 0">
        <div class="video-upload-progress__bar">
          <div class="video-upload-progress__fill" :style="{ width: Math.min(100, Math.max(0, progress)) + '%' }"></div>
        </div>
        <span class="video-upload-progress__label">{{ progress >= 100 && !uploading ? '100%' : 'Enviando… ' + Math.round(progress) + '%' }}</span>
      </div>
    </div>

    <!-- Input de upload -->
    <div class="upload-container" v-if="!previewUrl || showInput">
      <div class="file-wrapper">
        <input
          :id="inputId"
          class="file-input"
          type="file"
          :accept="accept"
          :multiple="multiple"
          @change="handleFileChange"
          :disabled="disabled"
        />
        <label :for="inputId" class="file-label">
          <div class="upload-icon">
            <fa icon="fa-video" />
          </div>
          <div class="upload-text">
            <span class="upload-title">{{ placeholder || 'Clique para fazer upload de vídeo' }}</span>
            <span class="upload-subtitle">{{ acceptText || 'Formatos aceitos: .mp4, .avi' }}</span>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoUploadInput',
  props: {
    label: {
      type: String,
      default: 'Carregue novos vídeos para sua coleção'
    },
    accept: {
      type: String,
      default: '.mp4, .avi'
    },
    acceptText: {
      type: String,
      default: 'Formatos aceitos: .mp4, .avi'
    },
    placeholder: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    previewUrl: {
      type: String,
      default: null
    },
    showInput: {
      type: Boolean,
      default: false
    },
    uploading: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      inputId: `video-upload-${Math.random().toString(36).substr(2, 9)}`
    };
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.$emit('file-selected', file, event);
      }
    },
    removePreview() {
      this.$emit('remove-preview');
    }
  }
};
</script>

<style scoped>
.video-upload-input {
  width: 100%;
}

.form-label {
  margin-bottom: 0.75rem;
}

.form-label label {
  font-weight: 500;
  color: #1a1a1a;
  font-size: 0.875rem;
  display: block;
}

.video-preview-wrapper {
  margin-bottom: 1rem;
}

.video-preview-container {
  position: relative;
  background: #ffffff;
  border-radius: 8px;
  padding: 8px;
  border: 1px solid #e5e7eb;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.video-preview {
  width: 100%;
  height: 100%;
  max-height: 100%;
  border-radius: 8px;
  background: #000;
  display: block;
  object-fit: contain;
}

.remove-preview-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  transition: all 0.2s ease;
  z-index: 10;
}

.remove-preview-btn:hover {
  background: rgba(220, 53, 69, 0.9);
  transform: scale(1.1);
}

.video-upload-progress {
  margin-top: 0.75rem;
}

.video-upload-progress__bar {
  height: 8px;
  border-radius: 999px;
  background: #e5e7eb;
  overflow: hidden;
}

.video-upload-progress__fill {
  height: 100%;
  background: #16a34a;
  border-radius: 999px;
}

.video-upload-progress__label {
  display: block;
  margin-top: 6px;
  color: #1a1a1a;
  font-size: 0.8125rem;
  font-weight: 600;
  text-align: right;
}

.upload-container {
  width: 100%;
}

.file-wrapper {
  position: relative;
  width: 100%;
}

.file-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.file-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1.5rem;
  border: 1px solid #e5e7eb !important;
  border-style: solid !important;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  min-height: 180px;
  height: 180px;
}

.file-label:hover {
  border-color: #150065;
  background: #fafbfc;
  box-shadow: 0 2px 8px rgba(21, 0, 101, 0.08);
}

.file-label:active {
  transform: translateY(0);
}

.file-input:disabled + .file-label {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

.upload-icon {
  margin-bottom: 1rem;
  color: #150065;
  font-size: 3rem;
  opacity: 0.8;
  transition: all 0.3s ease;
}

.file-label:hover .upload-icon {
  opacity: 1;
  transform: scale(1.1);
}

.upload-text {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.upload-title {
  font-weight: 600;
  color: #1a1a1a;
  font-size: 1rem;
}

.upload-subtitle {
  font-size: 0.75rem;
  color: #6b7280;
}

@media (max-width: 768px) {
  .file-label {
    padding: 2rem 1rem;
    min-height: 160px;
  }

  .upload-icon {
    font-size: 2.5rem;
  }

  .video-preview-container {
    height: 160px;
  }
  
  .file-label {
    height: 160px;
    min-height: 160px;
  }
}
</style>

